import type { CMSProductVariant } from '@/types/sanity'
import type { Cart, CartItem } from '@/types/shopify'

export const isSubscriptionLineItem = (line: CartItem) => {
  return !!line.sellingPlanAllocation?.sellingPlan
}

export const getLineItemRenewalInterval = (line: CartItem) => {
  if (!isSubscriptionLineItem(line)) return ''

  return getRenewalIntervalByBillingPolicy(
    line.sellingPlanAllocation!.sellingPlan.billingPolicy,
  )
}

export const getProductVariantRenewalInterval = (
  variant: CMSProductVariant,
) => {
  const billingPolicy = variant.sellingPlan?.billingPolicy
  if (!billingPolicy) return ''

  return getRenewalIntervalByBillingPolicy(billingPolicy)
}

export const getRenewalIntervalByBillingPolicy = (billingPolicy: {
  interval: string
  intervalCount: number
}): string => {
  const { interval, intervalCount } = billingPolicy
  if (intervalCount === 1) {
    return `${interval.toLowerCase()}ly`
  }
  // Intervals of 30, 60, and 90 days are treated as 1, 2, and 3 months
  if (interval === 'DAY' && intervalCount % 30 === 0) {
    const monthCount = intervalCount / 30
    return monthCount === 1 ? 'monthly' : `every ${monthCount} months`
  }

  return `every ${intervalCount} ${interval}s`
}

export const getCartAttributeByKey = (cart: Cart, key: string) => {
  return cart.attributes.find((attr) => attr.key === key)?.value
}

export const getLineItemAttributeByKey = (line: CartItem, key: string) => {
  return line.attributes.find((attr) => attr.key === key)?.value
}

export const replaceLineItemAttributeByKey = (
  line: CartItem,
  key: string,
  value: string,
) => {
  const attributes = [...line.attributes]
  const attrIndex = attributes.findIndex((attr) => attr.key === key)
  if (attrIndex === -1) return attributes
  attributes[attrIndex] = {
    key,
    value,
  }
  return attributes
}
